module.exports = __webpack_public_path__ + "fonts/icomoon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/icomoon/icomoon.svg
// module id = LFLR
// module chunks = 1